export const presigned = `https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/presigned`;
export const server = `https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod`;
